let rootRemotePHPDataBase = '';

if (typeof process === 'object' && process + '' === '[object process]') {
	let config = eval('require')('config');
	//is node
    rootRemotePHPDataBase = config.get('ClientAPI.oldAddress');
}
else {
	//not node
	rootRemotePHPDataBase = window['clientConfig'].oldSiteAddress; 
}

let rootPublicDataBase = '/database';
let rootPrivateDataBase = '/private/database';

let hostOnboarding = '/onboarding';
let accountDataBase = '/account';

export default {
	public: {
		database: {
			states: rootPublicDataBase + '/states',
			cities: rootPublicDataBase + '/cities',
			degrees: rootPublicDataBase + '/degrees',
			highSchools: rootPublicDataBase + '/highSchools',
			universities: rootPublicDataBase + '/universities',
			magors: rootPublicDataBase + '/magors',
			causes: rootPublicDataBase + '/causes',
			nonprofits: rootPublicDataBase + '/nonprofits'
		},

		remotePHPDataBase: {
			states: rootRemotePHPDataBase + '/?ajax=onboarding/states&limit=100',
			cities: rootRemotePHPDataBase + '/?ajax=onboarding/cities',
			highSchools: rootRemotePHPDataBase + '/?ajax=onboarding/highschools',
			universities: rootRemotePHPDataBase + '/?ajax=onboarding/schools',
			nonprofits: rootRemotePHPDataBase + '/?ajax=onboarding/nonprofits&limit=10000',
			save: rootRemotePHPDataBase + '/?ajax=onboarding/save',
			redirect: rootRemotePHPDataBase + '/?single_auth='
		},

		onboarding: {
			host: hostOnboarding,
			profile: hostOnboarding + '/profile'
		},
		files: {
			uploadFieldName: 'avatar'
		}
	},

	private: {
		database: {
			memberProfileData: rootPrivateDataBase + '/memberProfile/memberProfileData',
			generalInfoOfMember: rootPrivateDataBase + '/generalInfoOfUser',
			dashboardData: rootPrivateDataBase + '/dashboardData',
			states: rootPrivateDataBase + '/states',
			cities: rootPrivateDataBase + '/cities',
			degrees: rootPrivateDataBase + '/degrees',
			highSchools: rootPrivateDataBase + '/highSchools',
			universities: rootPrivateDataBase + '/universities',
			magors: rootPrivateDataBase + '/magors',
			causes: rootPrivateDataBase + '/causes',
			nonprofits: rootPrivateDataBase + '/nonprofits'
        },       
		files: {
			imageProfile: '/files/imageProfile',
			uploadFieldName: 'avatar'
		}
	}
}


// WEBPACK FOOTER //
// ./app.web.config.ts